<template>
    <main>
        <!-- breadcrumb area start here -->
        <section class="bd-breadcrumb-area p-relative fix theme-bg">
            <!-- breadcrumb background image -->
            <div class="bd-breadcrumb-bg" :style="{ backgroundImage: 'url(/img/bg/breadcrumb-bg.jpg)' }"></div>
            <div class="bd-breadcrumb-wrapper mb-60 p-relative">
                <div class="container">
                    <div class="bd-breadcrumb-shape d-none d-sm-block p-relative">
                        <div class="bd-breadcrumb-shape-1">
                        </div>
                        <div class="bd-breadcrumb-shape-2">
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-xl-10">
                            <div class="bd-breadcrumb d-flex align-items-center justify-content-center">
                                <div class="bd-breadcrumb-content text-center">
                                    <h1 class="bd-breadcrumb-title">Class VI to VIII</h1>
                                    <div class="bd-breadcrumb-list">
                                        <span><a href="/"><i class="flaticon-hut"></i>Home</a></span>
                                        <div class="bd-breadcrumb-list">
                                            <span><a href="#">Academics</a></span>
                                        </div>
                                        <span>Class VI to VIII</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bd-wave-wrapper bd-wave-wrapper-3">
                <div class="bd-wave bd-wave-3"></div>
                <div class="bd-wave bd-wave-3"></div>
            </div>
        </section>
        <!-- breadcrumb area end here  -->

        <!-- program details slider area start here  -->
        <section class="bd-program-details-widget pt-120 pb-70">
            <div class="container">
                <div class="row">
                    <div class="col-xl-6 col-lg-12 mb-50">
                        <div class="bd-program-details-slider p-relative wow fadeInLeft" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-program-details-active swiper-container">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <div class="bd-program-details-slider-thumb">
                                            <img src="/img/academics/3.png" alt="img not found!">
                                        </div>
                                    </div>
                                    <!-- <div class="swiper-slide">
                                 <div class="bd-program-details-slider-thumb">
                                    <img src="/img/program/home-program-2.jpg" alt="img not found!">
                                 </div>
                              </div>
                              <div class="swiper-slide">
                                 <div class="bd-program-details-slider-thumb">
                                    <img src="/img/program/home-program-3.jpg" alt="img not found!">
                                 </div>
                              </div> -->
                                </div>
                            </div>
                            <!-- program details slider navigation  -->
                            <div class="bd-program-details-navigation mb-15 d-none d-sm-flex">
                                <button class="bd-program-details-next">
                                    <i class="fa-regular fa-angle-right"></i>
                                </button>
                                <button class="bd-program-details-prev">
                                    <i class="fa-regular fa-angle-left"></i>
                                </button>
                            </div>
                            <div class="panel wow"></div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-12 mb-50">
                        <div class="bd-program-details-widget-content theme-bg-6 wow fadeInRight" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <h3 class="bd-program-details-widget-title mb-20">Class VI to VIII</h3>
                            <p class="mb-25">In this third stage of schooling, apart from academics, the child is also
                                involved and encouraged to participate in extracurricular activities, cultural programs
                                and excursions for his holistic development. </p>
                            <p class="mb-25">Along with the conventional education, Sanskrit is taught as a 3rd language
                                in our school. A well-balanced approach, that logically combines extracurriculars with
                                academics, is made at this stage to give a multi-pronged touch to the students’ overall
                                abilities.</p>
                            <div class="bd-program-details-author-wrapper mt-35">
                                <div class="bd-program-details-author">
                                    <div class="bd-program-details-author-name">
                                        <span>Fees per annum</span>
                                        <h5><a href="fees_structure.html">Click Here</a></h5>
                                    </div>
                                </div>
                                <div class="bd-program-details-cat">
                                    <span>Stage</span>
                                    <h5>Middle</h5>
                                </div>
                                <!-- <div class="bd-program-details-cat">
                              <span>Stage</span>
                              <h5>Middle</h5>
                           </div> -->
                                <!-- <div class="bd-program-details-cat">
                              <span>Duration/Day</span>
                              <h5>3.5 hrs*</h5>
                           </div> -->
                                <!-- <div class="bd-program-details-cat-wrapper">
                        </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- program details slider area end here  -->

        <!-- shop category area start here -->
        <section class="bd-shop-cat-area pb-90">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="bd-shop-cat-wrap mb-30 wow fadeInUp" data-wow-duration="1s" data-wow-delay=".2s">
                            <a href="#">
                                <div class="bd-shop-cat">
                                    <div class="bd-shop-cat-content">
                                        <div class="bd-shop-cat-title cat-1">
                                            <div class="bd-shop-cat-icon">
                                                <i class="flaticon-age-group"></i>
                                            </div>
                                        </div>
                                        <h6>11 - 13 years</h6>
                                        <span>age</span>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="bd-shop-cat-wrap mb-30 wow fadeInUp" data-wow-duration="1s" data-wow-delay=".3s">
                            <a href="#">
                                <div class="bd-shop-cat">
                                    <div class="bd-shop-cat-content">
                                        <div class="bd-shop-cat-title cat-2">
                                            <div class="bd-shop-cat-icon">
                                                <i class="flaticon-calendar"></i>
                                            </div>
                                        </div>
                                        <h6>6 Days</h6>
                                        <span>weekly</span>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="bd-shop-cat-wrap mb-30 wow fadeInUp" data-wow-duration="1s" data-wow-delay=".4s">
                            <a href="#">
                                <div class="bd-shop-cat">
                                    <div class="bd-shop-cat-content">
                                        <div class="bd-shop-cat-title cat-3">
                                            <div class="bd-shop-cat-icon">
                                                <i class="flaticon-clock-1"></i>
                                            </div>
                                        </div>
                                        <h6>6 Hrs</h6>
                                        <span>daily</span>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="bd-shop-cat-wrap mb-30 wow fadeInUp" data-wow-duration="1s" data-wow-delay=".5s">
                            <a href="#">
                                <div class="bd-shop-cat">
                                    <div class="bd-shop-cat-content">
                                        <div class="bd-shop-cat-title cat-2">
                                            <div class="bd-shop-cat-icon">
                                                <i class="flaticon-class"></i>
                                            </div>
                                        </div>
                                        <h6>Class Size</h6>
                                        <span>35 - 40</span>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- shop category area end here-->

        <!-- program routine area start here  -->
        <section class="bd-routine-area pb-70">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <div class="bd-section-title-wrapper text-center mb-55 wow fadeInUp" data-wow-duration="1s"
                            data-wow-delay=".2s">
                            <h2 class="bd-section-title mb-0">Full Day Learning & Fun!</h2>
                            <p>With the help of teachers and the environment, students<br> have
                                opportunities to learn new things.</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="bd-routine-table mb-50 wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".3s">
                            <table class="table table-striped">
                                <tbody>
                                    <tr>
                                        <td><strong>Subjects</strong></td>
                                        <td>Hindi, English, Math, Social Study, Science, Sanskrit, G.K., Computer</td>
                                    </tr>
                                    <tr>
                                        <td><b>Timing (Mon-Fri)</b></td>
                                        <td>08:00 am to 01:30 pm</td>
                                    </tr>
                                    <tr>
                                        <td><b>Timing (Sat)</b></td>
                                        <td>08:00 am to 01:00 pm</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        </section>
        <!-- program routine area end here  -->

        <!-- program details area start here  -->
        <section class="bd-program-details-widget pb-70 pt-10">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 mb-50">
                        <div class="bd-program-details-slider p-relative wow fadeInLeft" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-program-details-slider-thumb p-relative">
                                <img src="/img/academics/sec2.png" alt="img not found!">
                                <div class="panel wow"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 mb-50">
                        <div class="bd-program-details-widget-content theme-bg-6 wow fadeInRight" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <h3 class="bd-program-details-widget-title mb-20">Transformative Education</h3>
                            <p class="mb-25">Discover a world of opportunities at Baburam Vedanta Public School and
                                unlock your
                                child’s full potential.
                                Enroll now and be a part of a community that values growth, diversity, and the pursuit
                                of
                                excellence.</p>
                            <div class="bd-program-details-list">
                                <ul>
                                    <li><a href="admission_details.html">Admission Process</a></li>
                                    <li><a href="#">Fees Details</a></li>
                                    <li><a href="scholarship.html">Scholarships</a></li>
                                    <li><a href="campus.html">Campus Tour</a></li>
                                    <li><a href="staff.html">Staff</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- program details area end here  -->



    </main>
</template>
<script>
export default {
    name: "SecondaryView",
};
</script>
